// CategoriesSection.jsx
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import image1 from "../images/3.png";
import image2 from "../images/2.png";
import image3 from "../images/1.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Section
const Section = tw.div`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8`;

const SectionTitle = styled.h2`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #336734;
  position: relative;
  width: 100%;

  &::before,
  &::after {
    content: "";
    width: 90px;
    border-bottom: 2px solid #d3d3d3;
    margin: 0 1rem;
  }
`;

const CategoryGrid = tw.div`grid grid-cols-1 gap-y-0 gap-x-8`;

const CategoryCard = styled.div`
  ${tw`flex flex-col md:flex-row items-stretch bg-white rounded-lg overflow-hidden`}
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.06);

  @media (min-width: 768px) {
    flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  }
`;

const ImageContainer = styled.div`
  ${tw`w-full md:w-1/2 flex items-center justify-center bg-gray-100`}
  min-height: 250px;
  height: 250px;
  background: #f7f7f7;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const TextContainer = styled.div`
  ${tw`w-full md:w-1/2 p-6 flex flex-col justify-center items-center bg-white`}
  text-align: center;

  @media (min-width: 768px) {
    margin-left: ${({ reverse }) => (reverse ? "0" : "2rem")};
    margin-right: ${({ reverse }) => (reverse ? "2rem" : "0")};
  }
`;

const CategoryTitle = styled.h3`
  ${tw`text-lg font-semibold mb-2`}
  color: #336734;
`;

const CategoryDescription = tw.p`text-gray-600 mb-4 text-sm`;

const CategoryButton = styled(PrimaryButtonBase)`
  background: #336734;
  color: #fff;
  border: 2px solid #336734;
  font-size: 0.95rem;
  padding: 0.75rem 2rem;

  &:hover {
    background: #4a8a4a;
    border-color: #4a8a4a;
  }
`;

const CategoriesSection = () => {
  const { t } = useTranslation();

  const categories = [
    {
      title: t("categories.supplements.title"),
      description: t("categories.supplements.description"),
      image: image1,
      link: "/Complements",
    },
    {
      title: t("categories.cosmetics.title"),
      description: t("categories.cosmetics.description"),
      image: image2,
      link: "/Cosmetique",
    },
    {
      title: t("categories.packs.title"),
      description: t("categories.packs.description"),
      image: image3,
      link: "/Packs",
    },
  ];

  return (
    <Section>
      <SectionTitle>{t("categories.sectionTitle")}</SectionTitle>

      <CategoryGrid>
        {categories.map((cat, index) => (
          <CategoryCard key={index} reverse={index % 2 === 1}>
            <ImageContainer>
              <img src={cat.image} alt={cat.title} />
            </ImageContainer>

            <TextContainer reverse={index % 2 === 1}>
              <CategoryTitle>{cat.title}</CategoryTitle>
              <CategoryDescription>{cat.description}</CategoryDescription>

              <CategoryButton as={Link} to={cat.link}>
                {t("categories.button")}
              </CategoryButton>
            </TextContainer>
          </CategoryCard>
        ))}
      </CategoryGrid>
    </Section>
  );
};

export default CategoriesSection;
